export default __webpack_public_path__ + "static/media/jpeg-jpg-icon-map.8f0687e7.svg";